// Notification types
export const NOTIFICATION_TYPES = {
  INFO: 'info',
  SUCCESS: 'success',
  WARNING: 'warning',
  ERROR: 'error',
};

// Simulated server notifications
const SERVER_NOTIFICATIONS = [
  { type: NOTIFICATION_TYPES.SUCCESS, message: 'New image processing complete.' },
  { type: NOTIFICATION_TYPES.SUCCESS, message: 'Image uploaded successfully!' },
  { type: NOTIFICATION_TYPES.INFO, message: 'New user joined the platform.' },
  { type: NOTIFICATION_TYPES.INFO, message: 'Someone liked your photo.' },
  { type: NOTIFICATION_TYPES.INFO, message: 'New comment on your image.' },
  { type: NOTIFICATION_TYPES.SUCCESS, message: 'Your image was featured!' },
  { type: NOTIFICATION_TYPES.WARNING, message: 'Server maintenance scheduled.' },
  { type: NOTIFICATION_TYPES.SUCCESS, message: 'Backup completed successfully.' },
  { type: NOTIFICATION_TYPES.INFO, message: 'New follower!' },
  { type: NOTIFICATION_TYPES.SUCCESS, message: 'Image optimization complete.' },
];

// Create a notification object
const createNotification = (notification) => ({
  id: `${Date.now()}-${Math.random().toString(36).substr(2, 9)}`,
  ...notification,
  timestamp: new Date().toISOString(),
  read: false,
});

// Notification Service class
class NotificationService {
  constructor() {
    this.listeners = new Set();
    this.intervalId = null;
    this.isRunning = false;
  }

  // Subscribe to notifications
  subscribe(callback) {
    this.listeners.add(callback);
    return () => this.listeners.delete(callback);
  }

  // Notify all listeners
  notify(notification) {
    const newNotification = createNotification(notification);
    this.listeners.forEach(callback => callback(newNotification));
  }

  // Start background job
  start(intervalMs = 5000) {
    if (this.isRunning) return;

    this.isRunning = true;

    // Initial connection notification after 1 second
    setTimeout(() => {
      this.notify({
        type: NOTIFICATION_TYPES.SUCCESS,
        message: 'Connected to server.',
      });
    }, 1000);

    // Random notifications at interval
    this.intervalId = setInterval(() => {
      // 40% chance of notification each interval
      if (Math.random() > 0.6) {
        const randomIndex = Math.floor(Math.random() * SERVER_NOTIFICATIONS.length);
        this.notify(SERVER_NOTIFICATIONS[randomIndex]);
      }
    }, intervalMs);
  }

  // Stop background job
  stop() {
    if (this.intervalId) {
      clearInterval(this.intervalId);
      this.intervalId = null;
    }
    this.isRunning = false;
  }

  // Simulate async notification (like from a real server)
  simulateServerPush(delayMs = 2000) {
    return new Promise((resolve) => {
      setTimeout(() => {
        const randomIndex = Math.floor(Math.random() * SERVER_NOTIFICATIONS.length);
        const notification = createNotification(SERVER_NOTIFICATIONS[randomIndex]);
        this.notify(notification);
        resolve(notification);
      }, delayMs);
    });
  }
}

// Singleton instance
export const notificationService = new NotificationService();
